import { SalesImport } from '../translations-types';

const translations: SalesImport = {
  title: 'Importeren verkoopregels',
  description:
    'Importeer je verkopen uit Salonized (CSV-export van order_items). Dubbele regels worden automatisch overgeslagen en elke regel wordt gekoppeld aan een bestaande cliënt.',
  selectFile: 'CSV-bestand kiezen',
  importing: 'Bezig met importeren…',
  resultTitle: 'Resultaat',
  rows: 'Regels',
  imported: 'Geïmporteerd',
  duplicates: 'Duplicaten',
  matched: 'Gekoppeld',
  unmatched: 'Niet gekoppeld',
  ambiguous: 'Dubbelzinnig',
  noSalon: 'Selecteer eerst een salon.',
  importSuccess: 'Import voltooid.',
  importError: 'Importeren mislukt.',
  parseError: 'Kan het CSV-bestand niet lezen.',
  emptyFile: 'Het bestand bevat geen regels.',
  history: 'Eerdere imports',
  date: 'Datum',
  file: 'Bestand',
  importedBy: 'Door',
  noImports: 'Nog geen imports.',
};

export default translations;
